import React from 'react'
import { connect } from 'react-redux'
import {
    changePasswordAction,
    logOutAction,
} from '../../../actions/usersActions'
import { strings } from '../../../localization/strings'
import Loader from '../../loaders'
import { TextField, Button } from '@material-ui/core'

class Component extends React.Component {
    state = {
        changePasswordOld: '',
        changePasswordNew: '',
        changePasswordNewRetry: '',
    }

    handleSubmit = () => {
        this.props
            .changePasswordAction(
                this.state.changePasswordOld,
                this.state.changePasswordNew
            )
            .then(() =>
                window.showDialog(
                    {
                        title: strings.changePasswordSuccessTitle,
                        message: strings.changePasswordSuccess,
                    },
                    () => this.props.logOutAction()
                )
            )
            .catch((error) =>
                window.showDialog(error, () =>
                    this.setState({
                        loading: false,
                        changePasswordOld: '',
                        changePasswordNew: '',
                        changePasswordNewRetry: '',
                    })
                )
            )
    }

    render() {
        if (this.state.loader) return <Loader />

        return (
            <div>
                <div className={'centered-element-container'}>
                    <p>{strings.changePasswordDescription}</p>
                </div>

                <div className={'centered-element-container'}>
                    <TextField
                        id="passwordOld"
                        label={strings.changePasswordOld}
                        type={'password'}
                        value={this.state.changePasswordOld}
                        onChange={(ev) =>
                            this.setState({
                                changePasswordOld: ev.target.value,
                            })
                        }
                    />
                </div>

                <div className={'centered-element-container'}>
                    <TextField
                        id="passwordNew"
                        label={strings.changePasswordNew}
                        type={'password'}
                        value={this.state.changePasswordNew}
                        onChange={(ev) =>
                            this.setState({
                                changePasswordNew: ev.target.value,
                            })
                        }
                    />
                </div>

                <div className={'centered-element-container'}>
                    <TextField
                        id="passwordNewRetry"
                        label={strings.changePasswordNewRetry}
                        type={'password'}
                        value={this.state.changePasswordNewRetry}
                        onChange={(ev) =>
                            this.setState({
                                changePasswordNewRetry: ev.target.value,
                            })
                        }
                    />
                </div>

                <div className={'centered-element-container'}>
                    <Button
                        disabled={
                            !(
                                !!this.state.changePasswordOld &&
                                !!this.state.changePasswordNew &&
                                this.state.changePasswordNew ===
                                    this.state.changePasswordNewRetry
                            )
                        }
                        onClick={this.handleSubmit}
                        variant="contained"
                        color="primary"
                    >
                        {strings.changePasswordSubmit}
                    </Button>
                </div>
            </div>
        )
    }
}

const mapDispatchToProps = { changePasswordAction, logOutAction }
const mapStateToProps = (store) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(Component)
